import { FormCapture } from "./FormCapture";
import { FormServiceClient } from "../../FormLoader/src/FormServiceClient";
import { Logger } from "../../FormLoader/src/Logger";
export function formCaptureFactory(logger) {
    return function () {
        logger = logger !== null && logger !== void 0 ? logger : new Logger();
        return new FormCapture(logger, new FormServiceClient(logger));
    };
}
